var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("q-form", { ref: "editForm" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "선임명 정보" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            editable: _vm.editable,
                            disabled: "",
                            label: "LBL0010222",
                            name: "선임명",
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.seniorName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "seniorName",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.seniorName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-multi-select", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            isArray: false,
                            codeGroupCd: "REGULATION_BILL_API_CD",
                            itemText: "codeName",
                            itemValue: "code",
                            label: "LBL0010215",
                            name: "relatedLaws",
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.relatedLaws,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "relatedLaws",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.relatedLaws",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            rows: 2,
                            name: "qualifiyRequire",
                            label: "LBL0010228",
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.qualifiyRequire,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "qualifiyRequire",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.qualifiyRequire",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            name: "relatedReason",
                            label: "LBL0010229",
                            rows: 2,
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.relatedReason,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "relatedReason",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.relatedReason",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-textarea", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            name: "seniorReason",
                            label: "LBL0010230",
                            rows: 2,
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.seniorReason,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "seniorReason",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.seniorReason",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-xs-12 col-sm-12 col-md-9 col-lg-9 col-xl-9" },
            [
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm",
                  attrs: { title: "선임 정보" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-plant", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            type: "edit",
                            name: "plantCd",
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.plantCd,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "plantCd",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.plantCd",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-field", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            data: _vm.seniorDismissalStatus,
                            type: "dept_user",
                            deptValue: "seniorDeptCd",
                            label: "LBL0010223",
                            name: "seniorUserId",
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.seniorUserId,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "seniorUserId",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.seniorUserId",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            label: "LBL0010217",
                            name: "seniorDate",
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.seniorDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "seniorDate",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.seniorDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                            },
                            [
                              _c("c-radio", {
                                attrs: {
                                  disabled: "",
                                  editable: _vm.editable,
                                  comboItems: _vm.dismissalFlagItems,
                                  label: "LBL0010224",
                                  name: "dismissalFlag",
                                },
                                model: {
                                  value:
                                    _vm.seniorDismissalStatus.dismissalFlag,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.seniorDismissalStatus,
                                      "dismissalFlag",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "seniorDismissalStatus.dismissalFlag",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6",
                            },
                            [
                              _c("c-datepicker", {
                                attrs: {
                                  disabled: "",
                                  editable: _vm.editable,
                                  label: "LBL0010219",
                                  start: _vm.seniorDismissalStatus.seniorDate,
                                  name: "dismissalDate",
                                },
                                model: {
                                  value:
                                    _vm.seniorDismissalStatus.dismissalDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.seniorDismissalStatus,
                                      "dismissalDate",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "seniorDismissalStatus.dismissalDate",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ],
                2
              ),
              _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm q-mt-sm",
                  attrs: { title: "자격증 정보" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            label: "LBL0010225",
                            name: "relatedCertificate",
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.relatedCertificate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "relatedCertificate",
                                $$v
                              )
                            },
                            expression:
                              "seniorDismissalStatus.relatedCertificate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-text", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            label: "LBL0010226",
                            name: "certificateNo",
                          },
                          model: {
                            value: _vm.seniorDismissalStatus.certificateNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "certificateNo",
                                $$v
                              )
                            },
                            expression: "seniorDismissalStatus.certificateNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3",
                      },
                      [
                        _c("c-datepicker", {
                          attrs: {
                            disabled: "",
                            editable: _vm.editable,
                            label: "LBL0010227",
                            name: "certificateAcquiDate",
                          },
                          model: {
                            value:
                              _vm.seniorDismissalStatus.certificateAcquiDate,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.seniorDismissalStatus,
                                "certificateAcquiDate",
                                $$v
                              )
                            },
                            expression:
                              "seniorDismissalStatus.certificateAcquiDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("c-upload", {
                          attrs: {
                            attachInfo: _vm.attachInfo,
                            editable: false,
                            label: "LBL0010232",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }